@if (dataSource.data.length) {
  <div class="mb-3">
    <div class="border-b-ui-gray-light border-b-[1px] flex items-center justify-between">
      <mat-button-toggle-group
        class="desktop-toggle-group"
        (valueChange)="clientStatusFilter.set($event)"
        [value]="clientStatusFilter()"
        aria-label="Client Status"
        name="client-status"
      >
        <mat-button-toggle
          class="test-client-status-current"
          value="current"
        >
          <span class="item-status-title">Current</span>
        </mat-button-toggle>
        <mat-button-toggle
          class="test-client-status-archived"
          value="archived"
        >
          <span class="item-status-title">Archived</span>
        </mat-button-toggle>
      </mat-button-toggle-group>
      <app-search-input
        (searchDataEvent)="search.set($event)"
        placeholder="Enter Client Name"
      />
    </div>
  </div>

  <cdk-virtual-scroll-viewport
    [changeTrigger]="dataSource.filteredData"
    [tableId]="tableId()"
    avsVirtualTableScrollNormalizer
    itemSize="1"
  >
    <cdk-virtual-scroll-viewport-wrapper>
      <table
        id="clients-table"
        class="main-table"
        [dataSource]="dataSource"
        mat-table
        matSort
        matSortActive="friendlyName"
        matSortDirection="asc"
      >
        <!-- Number Column -->
        <ng-container matColumnDef="index">
          <th
            *matHeaderCellDef
            mat-header-cell
          >№</th>
          <td
            *matCellDef="let index = index"
            mat-cell
          >
            {{ index + 1 }}
          </td>
        </ng-container>

        <!-- Client Name Column -->
        <ng-container matColumnDef="friendlyName">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            sortActionDescription="Sort by client name"
          >Client Name</th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            @if (element.status !== eClientStatus.ARCHIVED) {
              <a
                class="underline cursor-pointer"
                (click)="selectClient(element.id)"
              >{{ element.friendlyName }}</a>
            } @else {
              <span>{{ element.friendlyName }}</span>
            }
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            sortActionDescription="Sort by status"
          >Status</th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            <avs-client-status [status]="element.status" />
          </td>
        </ng-container>

        <!-- Date Created Column -->
        <ng-container matColumnDef="created">
          <th
            *matHeaderCellDef
            mat-header-cell
            mat-sort-header
            sortActionDescription="Sort by date created"
          >
            Date Created
          </th>
          <td
            *matCellDef="let element"
            mat-cell
          >{{ element.createdOn | date : 'MM/dd/yy - hh:mm a' }}</td>
        </ng-container>

        <!-- Action Column -->
        <ng-container matColumnDef="actions">
          <th
            *matHeaderCellDef
            mat-header-cell
          ></th>
          <td
            *matCellDef="let element"
            mat-cell
          >
            @if (!element.isManagingClient) {
              <div class="flex items-center">
                @if (element.status === eClientStatus.ARCHIVED) {
                  <i
                    class="icon-restore action-icon"
                    (click)="unarchiveClient(element)"
                    matTooltip="Restore"
                  ></i>
                } @else {
                  <i
                    class="icon-edit action-icon"
                    (click)="selectClient(element.id)"
                    matTooltip="Edit"
                  ></i>
                  @if (element.status === eClientStatus.DEACTIVATED) {
                    <i
                      class="icon-active action-icon"
                      (click)="activateClient(element)"
                      matTooltip="Activate"
                    ></i>
                  } @else {
                    <i
                      class="icon-Deactivate action-icon"
                      (click)="deactivateClient(element)"
                      matTooltip="Deactivate"
                    ></i>
                  }
                  @if (element.status !== eClientStatus.ARCHIVED) {
                    <i
                      class="icon-add-to-archive action-icon"
                      (click)="archiveClient(element)"
                      matTooltip="Archive"
                    ></i>
                  }
                }
              </div>
            }
          </td>
        </ng-container>
        <tr
          *matHeaderRowDef="displayedColumns; sticky: true"
          mat-header-row
        ></tr>
        <tr
          [class.is-deactivated]="false"
          *matRowDef="let row; columns: displayedColumns"
          mat-row
        ></tr>
      </table>
    </cdk-virtual-scroll-viewport-wrapper>
    @if (!dataSource.filteredData.length) {
      <avs-no-data-placeholder [resultContent]="!!dataSource.data.length" />
    }
  </cdk-virtual-scroll-viewport>
} @else {
  <app-skeleton-table />
}
